import { SafeArea } from "antd-mobile";
import { FC, ReactNode } from "react";
import styled from "styled-components";

interface IProps {
  appContent: ReactNode;
}

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const AppBaseLayout: FC<IProps> = ({ appContent }) => {
  return (
    <>
      <SafeArea position="top" />
      <Container>
        {appContent}
      </Container>
      <SafeArea position="bottom" />
    </>
  );
};

export default AppBaseLayout;
